import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1702277441371'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='17608'
    >
        <path
            d='M815.55392 597.333333H187.07392V0h628.48a64 64 0 0 1 58.453333 89.173333l-82.346666 192.853334a42.666667 42.666667 0 0 0 0 33.706666l82.773333 192.853334A64 64 0 0 1 815.55392 597.333333z'
            fill='#FC284F'
            p-id='17609'
        ></path>
        <path
            d='M791.660587 315.306667a42.666667 42.666667 0 0 1-3.413334-16.64H187.07392v298.666666h628.48a64 64 0 0 0 58.88-89.173333z'
            fill='#C4264F'
            p-id='17610'
        ></path>
        <path
            d='M187.07392 1024a42.666667 42.666667 0 0 1-42.666667-42.666667V42.666667a42.666667 42.666667 0 0 1 85.333334 0v938.666666a42.666667 42.666667 0 0 1-42.666667 42.666667z'
            fill='#5E3841'
            p-id='17611'
        ></path>
    </svg>
)

export const FLAGIcon = props => <Icon component={SVG} {...props} />
